import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ type }) => {
  const navigate = useNavigate();

  const getEmptyStateContent = () => {
    switch (type) {
      case 'storefronts':
        return {
          icon: 'Store',
          title: 'Nessuna Vetrina Salvata',
          description: 'Inizia a esplorare le vetrine di Macerata e salva i tuoi negozi preferiti per accedervi rapidamente.',
          buttonText: 'Esplora Vetrine',
          buttonAction: () => navigate('/main-storefronts')
        };
      case 'promotions':
        return {
          icon: 'Tag',
          title: 'Nessuna Promozione Attiva',
          description: 'Scopri le promozioni disponibili nelle vetrine di Macerata e inizia a risparmiare sui tuoi acquisti.',
          buttonText: 'Scopri Promozioni',
          buttonAction: () => navigate('/main-storefronts')
        };
      case 'cashback':
        return {
          icon: 'Wallet',
          title: 'Nessuna Transazione',
          description: 'La tua cronologia cashback apparirà qui quando effettuerai acquisti presso le vetrine aderenti al programma.',
          buttonText: 'Trova Negozi con Cashback',
          buttonAction: () => navigate('/main-storefronts')
        };
      default:
        return {
          icon: 'AlertCircle',
          title: 'Nessun Contenuto',
          description: 'Non ci sono elementi da visualizzare al momento.',
          buttonText: 'Torna alla Home',
          buttonAction: () => navigate('/main-storefronts')
        };
    }
  };

  const content = getEmptyStateContent();

  return (
    <div className="flex flex-col items-center justify-center py-12 md:py-16 px-4">
      <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-muted/50 flex items-center justify-center mb-6">
        <Icon name={content?.icon} size={40} className="text-muted-foreground" />
      </div>
      <h3 className="font-heading text-xl md:text-2xl font-semibold text-foreground mb-3 text-center">
        {content?.title}
      </h3>
      <p className="font-body text-sm md:text-base text-muted-foreground text-center max-w-md mb-6">
        {content?.description}
      </p>
      <Button
        variant="default"
        size="default"
        iconName="ArrowRight"
        iconPosition="right"
        onClick={content?.buttonAction}
      >
        {content?.buttonText}
      </Button>
    </div>
  );
};

export default EmptyState;